import React from "react";

import Applet from "../../Applet";
import BillSubscriptionCommunicationTable from "../../../../components/BillConfiguration/BillSubscriptionCommunicationTable";

class BillSubscriptionCommunicationTableApplet extends Applet {

    render() {
        return <BillSubscriptionCommunicationTable applet={this}
                               pageSize={this.state.PageSize}
                               placement={this.state.Placement}
                               columns={this.state.Columns}
                               title="Subscription Communications"
                               enterpriseComponent={this.getEnterpriseComponent()}
                               sort={this.state.Sort}
                               menu={this.state.Menu}
                               rowHeight={this.state.RowHeight}
                               enableSort={true}
        />;
    }

    state= {
        Name: "BillSubscriptionCommunicationTableApplet",
        Menu: {
            options: [
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        RowHeight: 60,
        PageSize: {
            "default": 20,
            "xs": 3,
            "sm": 3,
            "md": 20,
            "lg": 20,
            "lx": 20,
        },
        Placement: {
            "xl": [
                {
                    id: "RecordPointer",
                },
                {
                    id: "USID",
                },
                {
                    id: "CreatedDatetime",
                },
                {
                    id: "PayloadString",
                }
            ],
        },
        Columns: [
            {
                id: "RecordPointer",
                width: 25,
                cellRenderer: "Row Selection Indicator Cell",
                header: null,
                headerRenderer: "",
                headerTitle: "",
            },
            {
                id: "USID",
                width: 300,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "USID",
            },
            {
                id: "CreatedDatetime",
                width: 300,
                cellRenderer: "Local Datetime Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Created Datetime",
            },
            {
                id: "PayloadString",
                width: 800,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Payload",
            }
        ],
        Sort: [
            {
                "Identifier": 1,
                "Visible": true,
                "Default": true,
                "Options": [{
                    "Direction": "ASC",
                    "SortAttribute": "Name",
                    "DisplayName": "Name",
                }],
            },
        ],
    }
}

export default BillSubscriptionCommunicationTableApplet;
